<template>
  <main id="app" @mousedown="pulse = !pulse" @mouseup="pulse = false">
    <NavBar />

    <vue-page-transition name="overlay-up-down">
      <router-view />
    </vue-page-transition>

    <CustomCursor :pulse="pulse" v-if="this.$route.name != '404 Error'" />

    <Social v-if="!this.$route.meta.requiresAuth" />

    <ShadowTitle v-if="!$route.meta.hideShadow" />

    <vue-page-transition name="fade">
      <PreloaderAnimation v-if="loading" />
    </vue-page-transition>

    <customScrollbar v-if="!hideScrollBar" />
    <Footer v-if="!$route.meta.hideFooter" />
  </main>
</template>

<script>
import NavBar from "@/components/NavBar";
import Social from "@/components/Social";

export default {
  components: {
    NavBar,
    Social,
    CustomCursor: () => import("@/components/CustomCursor"),
    Footer: () => import("@/components/Footer"),
    ShadowTitle: () => import("@/components/ShadowTitle"),
    customScrollbar: () => import("@/components/customScrollbar")
  },
  data() {
    return {
      pulse: false,
      loading: true
    };
  },
  computed: {
    hideScrollBar() {
      return this.loading || this.$route.meta.hideScrollBar;
    }
  },
  mounted() {
    this.loading = false;
    this.$router.beforeEach((to, from, next) => {
      this.loading = true;
      next();
    });
    this.$router.afterEach(() => {
      this.loading = false;
    });
  },
  metaInfo() {
    return {
      title: `${
        this.$route.meta.title ? this.$route.meta.title : this.$route.name
      }`,
      meta: [
        {
          property: "og:title",
          content: `${
            this.$route.meta.title ? this.$route.meta.title : this.$route.name
          }`
        },
        {
          property: "twitter:title",
          content: `${
            this.$route.meta.title ? this.$route.meta.title : this.$route.name
          }`
        }
      ]
    };
  }
};
</script>

<style lang="scss">
@import "node_modules/bootstrap/scss/bootstrap";
@import "@/assets/css/design.scss";
@import "@/assets/css/typography.scss";
@import "@/assets/css/nprogress.scss";

#app {
  position: relative;
}

.overlay-left,
.overlay-right,
.overlay-top,
.overlay-bottom {
  background: $primary !important;
  z-index: 90;
}
</style>
